import { createContext, useContext, useEffect, useRef, useState } from "react";
import { ASSETS } from "@/data";

const AudioCtx = createContext(null);

export const AudioProvider = ({ children }) => {
  const ref = useRef(null);
  const [playing, setPlaying] = useState(false);
  const [duration, setDuration] = useState(0);
  const [current, setCurrent] = useState(0);
  const [volume, setVol] = useState(0.8);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const a = new Audio(ASSETS.song);
    a.preload = "metadata";
    a.volume = volume;
    ref.current = a;
    const onTime = () => setCurrent(a.currentTime);
    const onMeta = () => setDuration(a.duration || 0);
    const onEnd = () => setPlaying(false);
    a.addEventListener("timeupdate", onTime);
    a.addEventListener("loadedmetadata", onMeta);
    a.addEventListener("ended", onEnd);
    return () => {
      a.pause();
      a.removeEventListener("timeupdate", onTime);
      a.removeEventListener("loadedmetadata", onMeta);
      a.removeEventListener("ended", onEnd);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const play = () => {
    if (!ref.current) return;
    setOpen(true);
    ref.current.play().then(() => setPlaying(true)).catch(() => {});
  };
  const pause = () => {
    ref.current?.pause();
    setPlaying(false);
  };
  const toggle = () => (playing ? pause() : play());
  const seek = (t) => {
    if (ref.current) {
      ref.current.currentTime = t;
      setCurrent(t);
    }
  };
  const setVolume = (v) => {
    setVol(v);
    if (ref.current) ref.current.volume = v;
  };

  return (
    <AudioCtx.Provider
      value={{ playing, duration, current, volume, open, setOpen, play, pause, toggle, seek, setVolume }}
    >
      {children}
    </AudioCtx.Provider>
  );
};

export const useAudio = () => useContext(AudioCtx);
